import { inject, Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { NavigationAction, NavigationDropdown, NavigationGroup, NavigationItem, NavigationLink, NavigationSubheading } from '../models/navigation-item.interface';
import { NavigationLoaderService } from './navigation-loader.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private readonly navigationLoaderService = inject(NavigationLoaderService);

  sidenavItems$ = this.navigationLoaderService.sidenavItems$;
  bottomNavItems$ = this.navigationLoaderService.bottomNavItems$;
  sidenavGroups$ = this.navigationLoaderService.sidenavGroups$;
  items$ = this.sidenavItems$;

  private _openChangeSubject = new Subject<NavigationDropdown>();
  openChange$ = this._openChangeSubject.asObservable();

  triggerOpenChange(item: NavigationDropdown) {
    this._openChangeSubject.next(item);
  }

  isLink(item: NavigationItem): item is NavigationLink {
    return item.type === 'link';
  }

  isDropdown(item: NavigationItem): item is NavigationDropdown {
    return item.type === 'dropdown';
  }

  isSubheading(item: NavigationItem): item is NavigationSubheading {
    return item.type === 'subheading';
  }

  isAction(item: NavigationItem): item is NavigationAction {
    return item.type === 'action';
  }
}
